import { defineStore } from 'pinia'
import { ref } from 'vue'
import { optionsApi, type CarSetDto } from '@/api/options'

export const useCarSetStore = defineStore('carSet', () => {
  const carSets = ref<CarSetDto[]>([])
  const isLoaded = ref(false)
  let fetchPromise: Promise<void> | null = null

  const fetchCarSets = async () => {
    if (isLoaded.value) return
    if (fetchPromise) return fetchPromise

    fetchPromise = (async () => {
      try {
        const response = await optionsApi.getCarSets()
        carSets.value = (response as unknown as CarSetDto[]) || []
        isLoaded.value = true
      } catch (error) {
        carSets.value = []
      }
    })()

    try {
      await fetchPromise
    } finally {
      fetchPromise = null
    }
  }

  return { carSets, isLoaded, fetchCarSets }
})
